import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { Provider } from 'mobx-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import App from './App';
import { helloStore } from './stores/HelloStore';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(_jsx(Provider, { helloStore: helloStore, children: _jsx(App, {}) }));
